export const style = {
  card: {
    cardHeader: {
      typography: {
        variant: 'h6',
        color: 'primary.text',
      },
      box: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
    sx: {
      mt: 5,
    },
    style: {
      position: 'relative',
    },
  },
  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },
} as const;
